module.exports = __webpack_public_path__ + "c3b5ca3b8dc66c126613fdb527eaaed1.svg";